import Add from "./AddButton.vue";
import Date from "./Date.vue";
import Delete from "./DeleteButton.vue";
import Label from "./Label.vue";
import Select from "./Select.vue";
import Text from "./Text.vue";
import Wrapper from "./Wrapper.vue";

export default { Add, Delete, Wrapper, Text, Select, Label, Date };
